import { render, staticRenderFns } from "./ProductGridBlog.vue?vue&type=template&id=e8689fe2&scoped=true"
import script from "./ProductGridBlog.vue?vue&type=script&lang=js"
export * from "./ProductGridBlog.vue?vue&type=script&lang=js"
import style0 from "./ProductGridBlog.vue?vue&type=style&index=0&id=e8689fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8689fe2",
  null
  
)

export default component.exports